export default __webpack_public_path__ + "static/map-5fb3d9b83cae467ef16cc5b32e667594.svg";